import React, { Component } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';
import errorImg from '../img/404/404-error.png';
import { appLogout } from '../libs/utils';
import { clearProfileIncompleteError } from './auth/keycloakUtils';

class ProfileIncompleteError extends Component {
  
  handleLogout = () => {
    clearProfileIncompleteError();
   
    appLogout();
  };

  render() {
    return (
      <Container className="container-error">
        <Row>
          <Col className="error">
            <img src={errorImg} className="logo" alt="Error" />
            <div className="block">
              <div className="profile-error-title">Error de Perfil</div>
              <div className="text">Hubo un problema con tu perfil de usuario.</div>
            </div>
          </Col>
        </Row>
        <Row style={{ marginTop: '55px' }}>
          <Col className="error">
            <div className="message">
              Tu perfil está incompleto o presenta información inconsistente. 
              Por favor, contacta al equipo de soporte para resolver este problema.
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="error">
            <div className="message">
              <strong>¿Necesitas ayuda?</strong> Envía un correo a soporte@porcobrar.com 
              o comunícate con nosotros por los canales habituales.
            </div>
          </Col>
        </Row>
        <Row>
          <Col className="error">
            <Button color="success" onClick={this.handleLogout}>
              Volver al Login
            </Button>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default ProfileIncompleteError;



// WEBPACK FOOTER //
// ./src/components/ProfileIncompleteError.js